import lozad from 'lozad'
import { runPageBlocks } from './blocks'
import bigPicture from 'bigpicture'


const { $ } = window
const $body = $(document.body)

export default {
  init() {

    /* load more */
    if (document.getElementById('load-more')) {
      let lm = document.getElementById('load-more');
      document.querySelector('#load-more a').addEventListener('click', function(e) {
        $.get('/wp-json/myplugin/v1/workpage/' + lm.dataset.currPage + '/' + lm.dataset.catid, function(data) {
          if (data == 'no posts') {
            document.querySelector('#load-more').remove();
          } else {
            document.getElementsByClassName('work-posts')[0].innerHTML += data;
            lm.dataset.currPage = +lm.dataset.currPage + 1;

            if (data.includes('<!-- last page -->')) {
              lm.remove();
            }
          }
        });
      })
    }

    /* instagram feed */
    if (document.querySelector('a.sbi_photo')) {
      let feedimgs = document.querySelectorAll('a.sbi_photo');

      for (let i = 0; i < feedimgs.length; i++) {
        feedimgs[i].addEventListener('click', function(e) {
          e.preventDefault();
           bigPicture({
            // element from which animation starts (required)
              el: feedimgs[i].querySelector('img'),
              // image url
              //imgSrc: 'https://yourimage.jpg',
              // video src (String) or sources (Array)
              //vidSrc: ['https://yourvideo.mp4', 'https://yourvideo.webm'],
              // iframe embed URL
              //iframeSrc: 'https://youriframe.html',
              // vimeo ID
              //vimeoSrc: '119287310',
              // youtube ID
              //ytSrc: 'z_PeaHVcohg',
              // use youtube-nocookie
              //ytNoCookie: false,
              // audio URL
              //audio: 'https://youraudio.mp3',
              // see below for more gallery options
              //gallery: '.sbi_images',
              // attribute used to find gallery elements
             // galleryAttribute: 'src',
              // set custom dimensions for embeds / videos
              //dimensions: [1920, 1080],
              // show or hide default loading indicator
              //noLoader: false,
              // customize the overlay color (any valid css color value)
              //overlayColor: 'rgba(0, 0, 0, .8)',
              // open animation callback
              animationStart: () => {},
              // open animation callback
              animationEnd: () => {},
              // close callback
              onClose: () => {},
              // gallery image change callback
              onChangeImage: () => {},
        })
      });
    }
  }

    /* team members */
    if (document.getElementsByClassName('team-photos')) {
      let teamimgs = document.querySelectorAll('.team-photos-entry img');


      for (let i = 0; i < teamimgs.length; i++) {
        teamimgs[i].addEventListener('click', function() {
          bigPicture({
          // element from which animation starts (required)
            el: document.querySelectorAll('.team-photos img')[i],
            // image url
            //imgSrc: 'https://yourimage.jpg',
            // video src (String) or sources (Array)
            //vidSrc: ['https://yourvideo.mp4', 'https://yourvideo.webm'],
            // iframe embed URL
            //iframeSrc: 'https://youriframe.html',
            // vimeo ID
            //vimeoSrc: '119287310',
            // youtube ID
            //ytSrc: 'z_PeaHVcohg',
            // use youtube-nocookie
            //ytNoCookie: false,
            // audio URL
            //audio: 'https://youraudio.mp3',
            // see below for more gallery options
            gallery: '.team-photos-entry',
            // attribute used to find gallery elements
            galleryAttribute: 'src',
            // set custom dimensions for embeds / videos
            dimensions: [1920, 1080],
            // show or hide default loading indicator
            noLoader: false,
            // customize the overlay color (any valid css color value)
            overlayColor: 'rgba(0, 0, 0, .8)',
            // open animation callback
            animationStart: () => {},
            // open animation callback
            animationEnd: () => {},
            // close callback
            onClose: () => {},
            // gallery image change callback
            onChangeImage: () => {},
          })
        });
      }
    }


    function recalculateNavHeight() {

      let navHeight;
      let mobileMenuPos;
      if ($('#wpadminbar')) {
        mobileMenuPos = $('.navbar-wrap').height() + $('#wpadminbar').height();
      } else {
        mobileMenuPos = $('.navbar-wrap').height();
      }

      navHeight = $('.navbar-wrap').height();
      
      document
        .querySelector(':root')
        .style.setProperty('--navbar-height', navHeight + 'px')
      $('#mobile-menu').css('top', mobileMenuPos + 'px')
      //console.log(navHeight)
    }
    window.onload = function() { recalculateNavHeight() }
    window.addEventListener('resize', () =>  recalculateNavHeight() )

    

    //TODO - section header
    // $(window).scroll(function() {
    // window.onscroll = () => {
    // window.addEventListener("scroll",function(){
    // document.addEventListener("scroll", function(){
    //   console.info('test')
    //   // if(Math.abs($('.section-header').position().top - $(window).scrollTop()) < 5) {    
    //   //   console.log('At Top')
    //   //   console.log(Math.abs($('.section-header').position().top - $(window).scrollTop()))
    //   // } 
    // })

    mobileMenu()

    runPageBlocks()
    
  },
  finalize() {

    /*const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) => (scrollWidth > clientWidth) || (scrollHeight > clientHeight)

    const resizeText = ({ element, elements, minSize = 10, maxSize = 512, step = 1, unit = 'px' }) => {
      (elements || [element]).forEach(el => {
        let i = minSize
        let overflow = false

            const parent = el.parentNode
        while (!overflow && i < maxSize) {
            el.style.fontSize = `${i}${unit}`
            overflow = isOverflown(parent)


          if (!overflow) i += step
        }

        // revert to last state where no overflow happened
        el.style.fontSize = `${i - step}/10${unit}`
      })
    }

    if (window.innerWidth > 768) {
      resizeText({
        elements: document.querySelectorAll('.image-grid-with-header-quote-quote h3'),
        step: 0.5
      })
    } else {
      resizeText({
        elements: document.querySelectorAll('.image-grid-with-header-quote-quote h3'),
        step: 0.5,
        maxSize: 60
      })
    }

    window.onresize = function() {
      if (window.innerWidth > 768) {
        resizeText({
          elements: document.querySelectorAll('.image-grid-with-header-quote-quote h3'),
          step: 0.5
        });
      } else {
        resizeText({
          elements: document.querySelectorAll('.image-grid-with-header-quote-quote h3'),
          step: 0.5,
          maxSize: 60
      })
      }
    }
    
    */

    // JavaScript to be fired on all pages, after page specific JS is fired
    // class to hide outlines if not using keyboard
    $body.on('mousedown', function () {
      $body.addClass('using-mouse')
    })
    $body.on('keydown', function () {
      $body.removeClass('using-mouse')
    })

    // scrolling instagram feed
    //if (document.getElementById('sbi_images')) {
      //document.getElementById('sbi_images').classList.add('dragscroll');
      //dragscroll.reset()
    //}

    //home
    let tops = Array.from(document.getElementsByClassName('image-grid-with-header-top'))
    let animatingTop = false;
    let animatingTop2 = false;
    window.onscroll = () => {
      if (window.innerWidth > 577) {
        tops.map((el, index) => { 
          if (index == 0) {
            if (animatingTop){ return; }
            if(!animatingTop && el.getBoundingClientRect().top <= 0) {
              el.classList.add('sticky')
              if (el.querySelector('.highlight')) {
                el.querySelector('.highlight').style.color = '#37619f';
              }
              animatingTop = true
              setTimeout(() => {
                animatingTop = false
                if (!animatingTop && el.getBoundingClientRect().top > 120) { //must be greater than new top created after shrink the text completely
                  el.classList.remove('sticky')
                  if (el.querySelector('.highlight')) {
                    el.querySelector('.highlight').style.color = '#e5e5e5';
                  }
                }
              }, 20)
            } else if (!animatingTop && el.getBoundingClientRect().top > 120) { //match; must be greater than new top created after shrink the text completely
              el.classList.remove('sticky')
              if (el.querySelector('.highlight')) {
                el.querySelector('.highlight').style.color = '#e5e5e5';
              }
            }
          } else if (index == 1) {
            if (animatingTop2){ return; }
            if(!animatingTop2 && el.getBoundingClientRect().top <= 0) {
              el.classList.add('sticky')
              if (el.querySelector('.highlight')) {
                el.querySelector('.highlight').style.color = '#37619f';
              }
              animatingTop2 = true
              setTimeout(() => {
                animatingTop2 = false
                if (!animatingTop2 && el.getBoundingClientRect().top > 120) { //must be greater than new top created after shrink the text completely
                  el.classList.remove('sticky')
                  if (el.querySelector('.highlight')) {
                    el.querySelector('.highlight').style.color = '#e5e5e5';
                  }
                }
              }, 20)
            } else if (!animatingTop2 && el.getBoundingClientRect().top > 120) { //match; must be greater than new top created after shrink the text completely
              el.classList.remove('sticky')
              if (el.querySelector('.highlight')) {
                el.querySelector('.highlight').style.color = '#e5e5e5';
              }
            }
          }
      });
    }
  }

    $('.back-top').on('click', () => {
      window.scrollTo(0,0)
    })
  },
}

function mobileMenu() {
  // assumes existence
  let $menu = $('#mobile-menu')
  $menu.hide()
  $menu.removeClass('loading')
  let $btn = $('#toggle_nav')

  $('main').on('click', function () {
    $menu.fadeOut()
  })
  
  let animating = false
  $btn.on('click', function (e) {
    if(animating) return
    animating = true
    $menu.fadeToggle()
    $body.toggleClass('mm-open')
    //throttle clicking
    setTimeout(() => {
      animating = false
    }, 400)
  })

  function closeOnDesktop(x) {
    if (x.matches) {
      $menu.fadeOut()
      $body.removeClass('mm-open')
    }
  }

  var x = window.matchMedia('(min-width: 768px)') //match
  closeOnDesktop(x)
  x.addListener(closeOnDesktop)
}

// function sectionHeader() {
// } sectionHeader()